import React, { FC } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

export interface Props {
  id: string;
  enabled: boolean;
  placeholder: string | undefined;
  value: number | undefined;
  touched?: boolean;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<any>;
  rest?: Record<string, unknown>;
  minValue?: number;
  maxValue?: number;
  readOnlyMode?: boolean;
}

const NumericInput: FC<Props> = ({
  id,
  minValue,
  maxValue,
  value,
  touched,
  error,
  enabled,
  placeholder,
  onChange,
  onBlur,
  rest,
  readOnlyMode,
}: Props) => {
  return (
    <InputGroup>
      <FormControl
        type="text"
        min={minValue}
        max={maxValue}
        name={id}
        inputMode={'numeric'}
        value={value}
        isValid={touched && !error}
        isInvalid={touched && !!error}
        disabled={!enabled || readOnlyMode}
        placeholder={readOnlyMode ? '' : placeholder}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value.match('^-?\\d*(\\.\\d*)?$') && onChange) {
            onChange(e);
          }
        }}
        onBlur={onBlur}
        {...rest}
        onWheel={(e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()}
      />
    </InputGroup>
  );
};

export default NumericInput;
